<template>


  <v-app id=”app” >

    <file-upload
            :accept="accept"
            :extensions="extensions"
            :multiple="false"
            :value="files"
            :headers="headers"
            :post-action="postAction"
            :data="fileData"
            @input="inputUpdateSet"
            @input-filter="inputFilter"
            ref="upload"
            name="upload"
            id="file"
    >
    </file-upload>



    <div @click="iAmActive()" class="login-app"v-if="
                  this.$route.name === 'Login'
                ">
      <router-view

      />
    </div>
    <div @click="iAmActive()" v-if="
                  this.$route.name !== 'Login'
                " >
      <v-navigation-drawer app v-bind:class="{'v-navigation-drawer--close v-navigation-drawer--is-mobile translate-none' : hidden}">
        <v-list>
          <v-list-item-group>
            <v-list-item v-for="item in menu" :key="item.text" :to="{name: item.name}">
              <v-list-item-content>
                <v-list-item-title>{{item.text}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>

      <v-app-bar app>
        <div class="header-data">
          <div class="header-data__left">
            <div class="hide-close">
              <span class="menu-close-button" @click="hideShow()">
                     <span class="menu-close"></span>
              </span>

            </div>
            <div class="logo-header">

            </div>
          </div>
          <div class="header-data__right">
            <div class="controls">
              <div class="controls__name">
                {{profile.forename}} {{profile.surname}}<br>
                <span>Přihlášen</span>
              </div>
              <div class="controls__logout">
                <v-btn
                        @click="logout()"
                        color="primary"
                        type="submit"
                        class="button--logout "
                >Odhlásit se</v-btn>
              </div>
            </div>
          </div>
        </div>

      </v-app-bar>

      <!-- Sizes your content based upon application components -->
      <v-main v-bind:class="{'main-left-0' : hidden}" class="main--content">

        <!-- Provides the application the proper gutter -->
        <v-container fluid>

          <!-- If using vue-router -->

          <router-view  />

          <flash-message></flash-message>
        </v-container>
      </v-main>
    </div>



  </v-app>
</template>

<script>
import FileUpload from 'vue-upload-component';
import {mapState} from 'vuex';
import moment from 'moment'
import XLSX from 'xlsx';

export default {
        name: 'App',
        components: {
            FileUpload
        },
        data() {
            return {
              filesData: [],
                uploadType: 'mp3',
                fileData:{},
                postAction: process.env.VUE_APP_API_BASE_URL + '/admin/upload/mp3',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                accept: 'audio/mpeg',
                extensions: ['mp3'],
                hidden: false,
                uploadId: null,

                data: {},
              menu: [
                  {
                      text: 'Úvod',
                      name: 'Dashboard'
                  },
           /*       {
                      text: 'Souhrn',
                      name: 'Overview'
                  },*/
                  {
                      text: 'Generované knihy',
                      name: 'Generating'
                  },
                  {
                      text: 'Objednávky',
                      name: 'Orders'
                  },

                  {
                      text: 'Zákazníci',
                      name: 'Customers'
                  },
                  {
                      text: 'Audioknihy',
                      name: 'Audiobooks'
                  },
                  {
                      text: 'Prodeje',
                      name: 'Sales'
                  },
                  {
                      text: 'Vyúčtování',
                      name: 'Billing'
                  },
                  {
                      text: 'Import do vyúčtování majitelům licencí',
                      name: 'BillingImport'
                  },
                  {
                      text: 'Vyúčtování majitelům licencí',
                      name: 'BillingAll'
                  },
                  {
                      text: 'Poukazy',
                      name: 'Vouchers'
                  },

                  {
                      text: 'Vydavatelé',
                      name: 'Publishers'
                  },
                  {
                      text: 'Autoři',
                      name: 'Authors'
                  },
                  {
                      text: 'Interpreti',
                      name: 'Interprets'
                  },
                  {
                      text: 'Kategorie',
                      name: 'Categories'
                  },
                  /*{
                      text: 'Statistiky',
                      name: 'Stats'
                  },*/
                  {
                      text: 'Widgety',
                      name: 'Widgets'
                  },


                  {
                      text: 'Blog',
                      name: 'Blog'
                  },
                  {
                      text: 'Autoři blogu',
                      name: 'ArticleAuthors'
                  },

                  {
                      text: 'Stránky',
                      name: 'Pages'
                  },
                  {
                      text: 'Nastavení',
                      name: 'Settings'
                  },

                {
                  text: 'Obrázky a soubory',
                  name: 'Files'
                },

                {
                  text: 'Notifikace',
                  name: 'Notifications'
                },

                {
                  text: 'Promo bar',
                  name: 'PromoBar'
                },

              ]
            }
        },
        created(){

            console.log(this.$route);

            this.$root.$on('select-audiobook-image', () => {
                this.uploadType = 'audiobook-image';
                this.headers = {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                };
                this.accept = 'image/png, image/jpeg';
                this.extensions = ['png','jpg', 'jpeg'];
                this.postAction = process.env.VUE_APP_API_BASE_URL + '/admin/upload/image';
                const vm = this;
                this.$nextTick(() => {
                    vm.selectFile();
                })

            });

            this.$root.$on('select-author-image', () => {
                this.uploadType = 'author-image';
                this.headers = {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                };
                this.accept = 'image/png, image/jpeg';
                this.extensions = ['png','jpg'];
                this.postAction = process.env.VUE_APP_API_BASE_URL + '/admin/upload/image';
                const vm = this;
                this.$nextTick(() => {
                    vm.selectFile();
                })

            });

            this.$root.$on('select-category-image', () => {
                this.uploadType = 'category-image';
                this.headers = {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                };
                this.accept = 'image/png, image/jpeg';
                this.extensions = ['png','jpg'];
                this.postAction = process.env.VUE_APP_API_BASE_URL + '/admin/upload/image';
                const vm = this;
                this.$nextTick(() => {
                    vm.selectFile();
                })

            });

            this.$root.$on('select-article-author-image', () => {
                this.uploadType = 'article-author-image';
                this.headers = {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                };
                this.accept = 'image/png, image/jpeg';
                this.extensions = ['png','jpg'];
                this.postAction = process.env.VUE_APP_API_BASE_URL + '/admin/upload/image';
                const vm = this;
                this.$nextTick(() => {
                    vm.selectFile();
                })

            });

          this.$root.$on('select-file', (id) => {

            this.uploadType = 'file';
            this.headers = {
              'Authorization': 'Bearer ' + localStorage.getItem('token')
            };
            this.accept = '';
            this.extensions = '';
            this.postAction = process.env.VUE_APP_API_BASE_URL + '/admin/upload/file';
            const vm = this;
            this.$nextTick(() => {
              vm.selectFile();
            })

          });
          this.$root.$on('start-upload-file', (id) => {
            if(this.filesData){
              this.uploadId = id;
              return this.inputUpdateAll(this.filesData);
            }
          });


          this.$root.$on('select-interpret-image', () => {
                this.uploadType = 'interpret-image';
                this.headers = {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                };
                this.accept = 'image/png, image/jpeg';
                this.extensions = ['png','jpg'];
                this.postAction = process.env.VUE_APP_API_BASE_URL + '/admin/upload/image';
                const vm = this;
                this.$nextTick(() => {
                    vm.selectFile();
                })

            });

            this.$root.$on('select-publisher-image', () => {
                this.uploadType = 'publisher-image';
                this.headers = {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                };
                this.accept = 'image/png, image/jpeg';
                this.extensions = ['png','jpg'];
                this.postAction = process.env.VUE_APP_API_BASE_URL + '/admin/upload/image';
                const vm = this;
                this.$nextTick(() => {
                    vm.selectFile();
                })

            });

            this.$root.$on('select-blog-image', () => {
                this.uploadType = 'blog-image';
                this.headers = {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                };
                this.accept = 'image/png, image/jpeg';
                this.extensions = ['png','jpg'];
                this.postAction = process.env.VUE_APP_API_BASE_URL + '/admin/upload/image';
                const vm = this;
                this.$nextTick(() => {
                    vm.selectFile();
                })

            });


            this.$root.$on('select-banner-image', (id) => {
                this.uploadId = id;
                this.uploadType = 'banner-image';
                this.headers = {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                };
                this.accept = 'image/png, image/jpeg';
                this.extensions = ['png','jpg'];
                this.postAction = process.env.VUE_APP_API_BASE_URL + '/admin/upload/banner';
                const vm = this;
                this.$nextTick(() => {
                    vm.selectFile();
                })

            });


            this.$root.$on('select-banner-page-image', (id) => {
                this.uploadId = id;
                this.uploadType = 'banner-page-image';
                this.headers = {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                };
                this.accept = 'image/png, image/jpeg';
                this.extensions = ['png','jpg'];
                this.postAction = process.env.VUE_APP_API_BASE_URL + '/admin/upload/banner-page';
                const vm = this;
                this.$nextTick(() => {
                    vm.selectFile();
                })

            });


            this.$root.$on('select-audiobook-example', () => {
                this.uploadType = 'audiobook-example';
                this.headers = {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                };
                this.accept = 'audio/mpeg';
                this.extensions = ['mp3'];
                this.postAction = process.env.VUE_APP_API_BASE_URL + '/admin/upload/mp3';
                const vm = this;
                this.$nextTick(() => {
                    vm.selectFile();
                })
            });

            this.$root.$on('select-audiobook-example-long', () => {
                this.uploadType = 'audiobook-example-long';
                this.headers = {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                };
                this.accept = 'audio/mpeg';
                this.extensions = ['mp3'];
                this.postAction = process.env.VUE_APP_API_BASE_URL + '/admin/upload/mp3';
                const vm = this;
                this.$nextTick(() => {
                    vm.selectFile();
                })
            });


            this.$root.$on('import-excel', (data) => {
                this.data = data;
                this.uploadType = 'excel';
                this.headers = {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                };
                this.accept = '.xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"';
                this.extensions = ['xls'];
                this.upload = 'excel';
                const vm = this;
                this.$nextTick(() => {
                    vm.selectFileImport();
                })

            });

            this.$store.commit('updateLastClick', moment(new Date()).format('D-M-YYYY HH:mm'));

            const vm = this;
            setInterval(function(){

                var twoHoursAgo = moment(new Date()).subtract('2', 'hours').format('D-M-YYYY HH:mm');
                var twoHoursAgoStamp = moment(twoHoursAgo).unix();
                var lastClickStamp = moment(vm.$store.state.lastClick).unix();


                if(lastClickStamp < twoHoursAgoStamp){

                    if(vm.$route.name !== 'Login'){
                        localStorage.removeItem('token');
                        vm.$router.push({name: 'Login'})
                    }

                }
            }, 3000);

        },
        computed: {
            ...mapState(['profile', 'files', 'lastClick']),
        },
        mounted() {


        },
        methods: {
            iAmActive(){
                console.log('im active')
                this.$store.commit('updateLastClick', moment(new Date()).format('D-M-YYYY HH:mm'));
            },
            selectFile(){
                console.log("this.files", this.files)
                if(this.files.length > 0){

                    this.$store.commit('updateFiles', []);
                }
                var link = document.getElementById('upload');
                link.click()
                console.log("Clicked?")

            },
            selectFileImport(){

                if(this.files.length > 0){
                    this.$store.commit('updateImportData', []);
                }
                var link = document.getElementById('upload');
                link.click()

            },
            inputFilter(newFile, oldFile, prevent) {
                console.log('newFile')
                console.log(newFile)
                console.log('oldFile')
                console.log(oldFile)
                console.log('prevent')
                console.log(prevent)
                newFile.data.id = this.uploadId;

                if(newFile.progress){
                  if(this.uploadType === 'file'){
                    console.log('progress', newFile.progress)
                    this.$root.$emit('percentage-file', newFile.progress);
                  }
                }

                if(newFile.active){
                    if(this.uploadType === 'audiobook-image'){
                        this.$root.$emit('upload-audiobook-image');
                    }else if(this.uploadType === 'banner-image'){
                        this.$root.$emit('upload-banner-image');
                    }else if(this.uploadType === 'banner-page-image'){
                        this.$root.$emit('upload-banner-page-image');
                    }else if(this.uploadType === 'blog-image'){
                        this.$root.$emit('upload-blog-image');
                    }else if(this.uploadType === 'audiobook-example'){
                        this.$root.$emit('upload-audiobook-example');
                    }else if(this.uploadType === 'audiobook-example-long'){
                        this.$root.$emit('upload-audiobook-example-long');
                    }else if(this.uploadType === 'author-image'){
                        this.$root.$emit('upload-author-image');
                    }else if(this.uploadType === 'category-image'){
                        this.$root.$emit('upload-category-image');
                    }else if(this.uploadType === 'article-author-image'){
                        this.$root.$emit('upload-article-author-image');
                    }else if(this.uploadType === 'interpret-image'){
                        this.$root.$emit('upload-interpret-image');
                    }else if(this.uploadType === 'publisher-image'){
                        this.$root.$emit('upload-publisher-image');
                    }else if(this.uploadType === 'file'){
                      this.$root.$emit('upload-file');
                    }
                }

                if(newFile.success){

                    if(this.uploadType === 'audiobook-image'){
                        this.$root.$emit('uploaded-audiobook-image', newFile.response);
                    }else if(this.uploadType === 'banner-image'){
                        this.$root.$emit('uploaded-banner-image', newFile.response);
                    }else if(this.uploadType === 'banner-page-image'){
                        this.$root.$emit('uploaded-banner-page-image', newFile.response);
                    }else if(this.uploadType === 'blog-image'){
                        this.$root.$emit('uploaded-blog-image', newFile.response);
                    }else if(this.uploadType === 'audiobook-example'){
                        this.$root.$emit('uploaded-audiobook-example', newFile.response);
                    }else if(this.uploadType === 'audiobook-example-long'){
                        this.$root.$emit('uploaded-audiobook-example-long', newFile.response);
                    }else if(this.uploadType === 'author-image'){
                        this.$root.$emit('uploaded-author-image', newFile.response);
                    }else if(this.uploadType === 'category-image'){
                        this.$root.$emit('uploaded-category-image', newFile.response);
                    }else if(this.uploadType === 'article-author-image'){
                        this.$root.$emit('uploaded-article-author-image', newFile.response);
                    }else if(this.uploadType === 'interpret-image'){
                        this.$root.$emit('uploaded-interpret-image', newFile.response);
                    }else if(this.uploadType === 'publisher-image'){
                        this.$root.$emit('uploaded-publisher-image', newFile.response);
                    }else if(this.uploadType === 'file'){
                      this.$root.$emit('uploaded-file', newFile.response);
                    }

                    this.$store.commit('updateFiles', []);

                }
                if(newFile.error){
                    this.$store.commit('updateFiles', []);
                  if(this.uploadType === 'file'){
                    this.$root.$emit('failed-file', newFile.response);
                  }
                }
            },
            inputUpdateSet(files){
                if(this.uploadType === 'excel'){
                    return this.inputUpdate(files);
                }else{
                  if(this.uploadType === 'file') {
                    this.$root.$emit('selected-file', files);
                    this.filesData = files;

                  }else{
                    return this.inputUpdateAll(files);
                  }
                }
            },
            inputUpdateAll(files){

                this.$refs.upload.active = true;

            },
            inputUpdate(files){

              const vm = this;
              var f =  files[0].file;
              var reader = new FileReader();
              reader.onload = function(e) {


                console.log('RESULT', e.target.result)
                var data = e.target.result
                console.log('RAWDATAAA', data)
                var workbook = XLSX.read(data, {type: 'binary'});
                console.log('workbook', workbook);
                let sheetName = workbook.SheetNames[0];
                /* DO SOMETHING WITH workbook HERE */



                console.log('sheetName', sheetName);
                let worksheet = workbook.Sheets[sheetName];
                console.log('worksheet', worksheet);





               // console.log('XLSX', XLSX.utils.sheet_to_json(worksheet, { raw: false }));
                vm.importedJson = XLSX.utils.sheet_to_json(worksheet);

               //  const utf8 = require('utf8');
                vm.importedJson.forEach(item => {
                  //  item.audiobook = utf8.decode(item.audiobook)
                  item.price = String( item.price).replace(',','.');
                  item.price= parseFloat(item.price).toFixed(2)
                })
                console.log('DATAAAA-JSON', vm.importedJson)
                console.log('DATAAAA', vm.data)

                vm.$store.commit('updateImportData', vm.importedJson);
                vm.$store.commit('updateImportDataValues', vm.data);
                vm.$router.push({name: 'BillingImportMake'});
              };
              reader.readAsBinaryString(f);


          /*      const vm = this;
                var f =  files[0].file;
                var reader = new FileReader();
                reader.onload = function(e) {


                  console.log('RESULT', e.target.result)
                    var enc = new TextDecoder("utf-8");
                    var data = new Uint8Array(e.target.result);

                    data = enc.decode(data);
                    console.log('RAWDATAAA', data)
                    var workbook = XLSX.read(data, {type: 'string', raw: true});
                    console.log('workbook', workbook);
                    let sheetName = workbook.SheetNames[0];
                    /!* DO SOMETHING WITH workbook HERE *!/



                    console.log('sheetName', sheetName);
                    let worksheet = workbook.Sheets[sheetName];
                    console.log('worksheet', worksheet);





                    console.log('XLSX', XLSX.utils.sheet_to_json(worksheet, { raw: false }));
                    vm.importedJson = XLSX.utils.sheet_to_json(worksheet, { raw: false });

                  //  const utf8 = require('utf8');
                    vm.importedJson.forEach(item => {
                      //  item.audiobook = utf8.decode(item.audiobook)
                      item.price = String( item.price).replace(',','.');
                    })
                    console.log('DATAAAA-JSON', vm.importedJson)
                    console.log('DATAAAA', vm.data)

                    vm.$store.commit('updateImportData', vm.importedJson);
                    vm.$store.commit('updateImportDataValues', vm.data);
                    vm.$router.push({name: 'BillingImportMake'});
                };
                reader.readAsArrayBuffer(f);*/

            },
            hideShow(){
                this.hidden = !this.hidden;
            },
            logout(){

                localStorage.removeItem('token');
                this.$router.push({name: 'Login'});
            }

        },
        watch: {


        }
    }
</script>


<style lang="scss"  >
  @import "@/assets/sass/style.scss";
</style>
